"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLastDepositTransaction = void 0;
var pay_api_1 = require("@l2p/pay-api");
var react_1 = require("react");
var keys_1 = require("../keys");
var useQuery_1 = require("../useQuery");
var useLastDepositTransaction = function () {
    var _a = (0, useQuery_1.useQuery)({
        path: keys_1.PROFILE_LAST_DEPOSIT_TRANSACTION,
        revalidateOnMount: true,
        payload: {
            filter: {
                type: pay_api_1.TransactionTypeEnum.Deposit,
            },
            pagination: {
                page: 0,
                limit: 1,
            },
        },
    }), data = _a.data, error = _a.error, isLoading = _a.isLoading, mutate = _a.mutate;
    return (0, react_1.useMemo)(function () { return ({
        data: data === null || data === void 0 ? void 0 : data.data,
        isLoading: isLoading,
        error: error,
        mutate: mutate,
    }); }, [data, isLoading, error, mutate]);
};
exports.useLastDepositTransaction = useLastDepositTransaction;
